import { ClipboardCopyElement } from './clipboard-copy-element.js';
export { ClipboardCopyElement };
export default ClipboardCopyElement;
export * from './clipboard-copy-element-define.js';
